import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabPanel, a11yProps } from '../../../../../UI/MuiTab';
import DocumentsTehnicka from './Documents/Documents';
import { useTranslation } from 'react-i18next';
import ZSGridProvider from './ZSGridProvider/ZSGridProvider';
import RNGridProvider from './RNGridProvider/RNGridProvider';
import PONUGridProvider from './PONUGridProvider/PONUGridProvider';
import RNPURGridProvider from './RNPURGridProvider/RNPURGridProvider';

const PregledKlijenata = ({ machine }) => {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              label={t('technicalDocumentation')}
              {...a11yProps(0)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              label={t('instruction')}
              {...a11yProps(1)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              label={t('administrativeDocumentation')}
              {...a11yProps(2)}
              sx={{ textTransform: 'none' }}
            />
            {machine.tipPregled === 'detalji' && (
              <Tab
                label={t('serviceRequests')}
                {...a11yProps(3)}
                sx={{ textTransform: 'none' }}
              />
            )}
            {machine.tipPregled === 'detalji' && (
              <Tab
                label={t('workOrders')}
                {...a11yProps(4)}
                sx={{ textTransform: 'none' }}
              />
            )}
            {machine.tipPregled === 'detalji' && (
              <Tab
                label={t('commissioning')}
                {...a11yProps(5)}
                sx={{ textTransform: 'none' }}
              />
            )}
            {machine.tipPregled === 'detalji' && (
              <Tab
                label={t('offers')}
                {...a11yProps(6)}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Box>
      </Box>

      <TabPanel value={value} index={0}>
        <DocumentsTehnicka
          idMasine={machine.id}
          kategorija={1}
          idTipaMasine={machine.idTipaMasine}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DocumentsTehnicka
          idMasine={machine.id}
          kategorija={2}
          idTipaMasine={machine.idTipaMasine}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DocumentsTehnicka
          idMasine={machine.id}
          kategorija={3}
          idTipaMasine={machine.idTipaMasine}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ZSGridProvider idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <RNGridProvider idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <RNPURGridProvider idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <PONUGridProvider idMasine={machine.id} />
      </TabPanel>
    </>
  );
};

export default PregledKlijenata;
